module.exports = __webpack_public_path__ + "assets/img/creation_icon_c.f2ebdee4.png";